import styled from "styled-components";

import { BillingFormModalStyledProps as Props } from "./BillingFormModal.types";

const BillingFormModalStyled = styled.div<Props>`
  .BillingFormModal {
    background-color: var(--palette-black-s2-l17);

    &&& .Modal__body {
      background-color: var(--palette-black-s2-l17);
    }
  }
`;

export default BillingFormModalStyled;
